export default "__VITE_ASSET__D$Z3i2Kx__"